<template>
  <div class="new-main-footer-revamp__item__download">
    <div class="new-main-footer-revamp__item__download__title">
      Dapatkan aplikasinya
    </div>
    <div class="new-main-footer-revamp__item__download__icon">
      <div>
        <a
          v-if="!isAppleDevice"
          :href="link.android"
          target="_blank"
        >
          <img
            id="Download_Google_Play_Footer_New"
            :src="PlayStore"
            alt="playStore_logo"
            height="100%"
            width="100%"
          >
        </a>
      </div>
      <div>
        <a
          :href="link.ios"
          target="_blank"
        >
          <img
            id="Download_Appstore_Footer_New"
            :src="AppStore"
            alt="appstore_logo"
            height="100%"
            width="100%"
          >
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import PlayStore from "@/assets/playStore.svg";
import AppStore from "@/assets/appStore.svg";
import { setImageDefault } from '@/components/ImageLazy/util';

export default {
  name: "DownloadApp",
  data() {
    return {
      PlayStore,
      AppStore,
      link: {
        android: "https://play.google.com/store/apps/details?id=com.lionparcel.services.consumer&hl=in",
        ios: "https://apps.apple.com/id/app/lion-parcel/id1455977134",
      },
      isAppleDevice: false,
    }
  },
  mounted() {
    this.isAppleDevice = this.isApple()
  },
  methods: {
    openLink(os) {
      window.open(this.link[os], "_blank");
    },
    setErrorImage(event, addClass) {
      setImageDefault(event, addClass)
    },
    isApple() {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator?.userAgentData?.platform)
        || /iPad|iPhone|iPod/.test(navigator.userAgent)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    },
  }
}
</script>
